export function PinIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M7 2C5.078 2 4.262 4.447 5.8 5.6l.8.6A1 1 0 017 7v4a1 1 0 01-.4.8l-.8.6C4.262 13.553 5.078 16 7 16h4v5a1 1 0 102 0v-5h4c1.922 0 2.738-2.447 1.2-3.6l-.8-.6a1 1 0 01-.4-.8V7a1 1 0 01.4-.8l.8-.6C19.738 4.447 18.922 2 17 2H7zm0 2h10l-.8.6A3 3 0 0015 7v4a3 3 0 001.2 2.4l.8.6H7l.8-.6A3 3 0 009 11V7a3 3 0 00-1.2-2.4L7 4z"
      ></path>
    </svg>
  );
}
